import { CoreMeasure } from '@bepatient/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TakeMeasureActions,
  TakeMeasureActionTypes
} from './take-measure.actions';

interface TakeMeasureState {
  measuresList: Array<CoreMeasure>;
}

export const takeMeasureInitialState: TakeMeasureState = {
  measuresList: []
};

export function takeMeasureReducer(
  state = takeMeasureInitialState,
  action: TakeMeasureActions
): TakeMeasureState {
  switch (action.type) {
    case TakeMeasureActionTypes.LOAD_MEASURES_LIST_SUCCESS:
      return { ...state, measuresList: action.payload };

    default:
      return state;
  }
}

const takeMeasureState = createFeatureSelector<TakeMeasureState>('takeMeasure');

export const selectorTakeMeasureMeasuresList = createSelector(
  takeMeasureState,
  state => state.measuresList
);
